import { defineStore } from 'pinia';
const STORAGE_KEY = 'kuere:session';
function toStoredUser(user) {
    return { id: user.id, first_name: user.first_name, last_name: user.last_name };
}
export const useAuthStore = defineStore('auth', {
    state: () => ({
        user: null,
    }),
    getters: {
        isLogged: (state) => !!state.user,
    },
    actions: {
        setUser(user) {
            this.user = user;
            // Solo persistir campos no sensibles
            localStorage.setItem(STORAGE_KEY, JSON.stringify(toStoredUser(user)));
        },
        loadUser() {
            const stored = localStorage.getItem(STORAGE_KEY);
            if (!stored)
                return;
            try {
                const parsed = JSON.parse(stored);
                // Validar forma mínima antes de hidratar el store
                if (typeof parsed?.id === 'number' && typeof parsed?.first_name === 'string') {
                    // Reconstruimos un User parcial; los arrays se rellenarán
                    // desde la API en el primer fetch de Show.vue
                    this.user = {
                        ...parsed,
                        last_name: parsed.last_name ?? '',
                        email: '',
                        phone: '',
                        status: '',
                        favorite_products: [],
                        product_rankings: [],
                        preferences: [],
                    };
                }
            }
            catch {
                // JSON corrupto → limpiar
                localStorage.removeItem(STORAGE_KEY);
            }
        },
        logout() {
            this.user = null;
            localStorage.removeItem(STORAGE_KEY);
            // Limpiar clave antigua por si existe en navegadores previos
            localStorage.removeItem('user');
        },
    }
});
//# sourceMappingURL=auth.js.map